import React, { useState } from "react";
import "./Upload.css";
import axios from "axios";

function Upload(props) {
  const [file, setFile] = useState();
  const [qnt, setQnt] = useState("");
  console.log(props.Uuid);
  const table = {
    border: "1px solid black",
    borderRadius:"20px",
    textAlign: "center",
    padding: "8px",
    fontSize: "15px",
    fontFamily:"Helvetica",
  }
  const handleFileChange = async (file) => {
    try {
      axios
        .post("http://localhost:5000/imgUpload?qnt=" + qnt, file, {
          method: "post",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          body: {
            qnt: qnt,
          },
        })
        .then((response) => {
          console.log("File uploaded successfully:", response.data);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  const handleSubmit = () => {
    if (file instanceof Blob) {
      const reader = new FileReader();
      const formdata = new FormData();
      formdata.append("file", file);
      console.log(formdata);
      reader.readAsDataURL(file);
      reader.onload = function () {
        console.log(reader.result);
        handleFileChange(formdata);
      };
    } else {
      console.error("The selected file is not a Blob or File.");
    }
  };
  return (
    <div
      style={{
        padding: "20px",
        marginBottom: "20px",
      }}
      className="bu"
    >
      <div className="upload">
        <h1 className="upload-head">
          Capture the photo of the meal you enjoyed today.
        </h1>
        <label className="desc">
          Take a photo of the meal you ate today and upload it
        </label>
        <div style={{ margin: "0 auto" }}>
          <label className="upbtn" for="upimg">
            Upload
          </label>
          <input
            id="upimg"
            className="typein"
            type="file"
            accept="image/jpeg, image/png"
            onChange={(e) => {
              setFile(e.target.files[0]);
            }}
          />
          <select
            className="sub-inp"
            onChange={(e) => {
              setQnt(e.target.value);
            }}
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
          <button onClick={handleSubmit}>Submit</button>
        </div>
      </div>
      <div className="popout">
        <img width/>
        <h1>Pizza</h1>
        <table
          style={{
            position: "absolute",
            margin: "20px",
            marginTop: "150px",
            width: "80%",
            borderRadius:"20px",
            fontSize:'10px'
          }}
        >
          <tr>
            <th style={table}>Nutrients</th>
            <th style={table}>Amount</th>
          </tr>
          <tr>
            <td style={table}>Calories</td>
            <td style={table}>{567}</td>
          </tr>
          <tr>
            <td style={table}>Carbohydrates</td>
            <td style={table}>{567}</td>
          </tr>
          <tr>
            <td style={table}>Protein</td>
            <td style={table}>{657}</td>
          </tr>
          <tr>
            <td style={table}>Fat</td>
            <td style={table}>{567}</td>
          </tr>
          <tr>
            <td style={table}>Fibre</td>
            <td style={table}>{567}</td>
          </tr>
        </table>
      </div>
      <div className="sec-row"></div>
    </div>
  );
}

export default Upload;
